
export default {
  props: {
    item: {
      type: String,
    },
    variant: {
      type: String,
    },
    active: {
      type: Boolean,
      default: false,
    },
    removeActiveItem: Function,
    setActiveItem: Function,
  },
};
